import { render, staticRenderFns } from "./DeliveryFeeDetails.vue?vue&type=template&id=4eec73a3&scoped=true"
import script from "./DeliveryFeeDetails.vue?vue&type=script&lang=js"
export * from "./DeliveryFeeDetails.vue?vue&type=script&lang=js"
import style0 from "./DeliveryFeeDetails.vue?vue&type=style&index=0&id=4eec73a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eec73a3",
  null
  
)

export default component.exports